module.exports = __webpack_public_path__ + "img/bg.64368a44.jpg";